import React from 'react';
import { Button, Tooltip, Typography } from '@material-ui/core';
import clsx from 'clsx';
import { FuseAnimate } from '@fuse';
import useStyles from 'app/cluster-styles/useStyles';

export default function ClusterFormHeader({
    provider, providerLabel, marketplace,
    advanced, onToggleAdvanced,
    isFormValid, formInvalidReason, loading, disableInputs,
    formType, onSave, onEdit, onClose,
    subtitle,
}) {
    const classes = useStyles();

    return (
        <div className="flex flex-1 w-full items-center justify-between">
            <div className="flex flex-col max-w-full">
                <div className="flex items-center max-w-full">
                    <FuseAnimate animation="transition.expandIn" delay={300}>
                        <img
                            id={`${provider}_provider-logo`}
                            className="w-32 sm:w-48 mr-8 sm:mr-16 rounded"
                            src={marketplace.imageSrc}
                            alt="Provider Logo"
                        />
                    </FuseAnimate>
                    <div className="flex flex-col min-w-0">
                        <FuseAnimate animation="transition.slideLeftIn" delay={300}>
                            <Typography id={`${provider}_cluster-name-header`} className="text-16 text-white sm:text-20 truncate">
                                {marketplace.title}
                            </Typography>
                        </FuseAnimate>
                        <FuseAnimate animation="transition.slideLeftIn" delay={300}>
                            <Typography id={`${provider}_provider-name-header`} className="text-white" variant="caption">
                                {providerLabel}{subtitle ? ` ${subtitle}` : ''}
                            </Typography>
                        </FuseAnimate>
                    </div>
                </div>
            </div>
            <div>
                <Button
                    className="whitespace-no-wrap mr-2"
                    id={`${provider}_advanced-btn`}
                    variant="contained"
                    onClick={onToggleAdvanced}
                >
                    {advanced ? "Basic" : "Advanced"}
                </Button>
                {formType === 'new' && (
                    // Tooltip wraps a <span> so it still shows when the button is disabled
                    // (disabled buttons don't fire the hover events Tooltip listens for).
                    // An empty title renders no tooltip, so a valid form shows nothing.
                    <Tooltip arrow title={!isFormValid ? (formInvalidReason || 'Complete all required fields to save.') : ''}>
                        <span>
                            <Button
                                className="whitespace-no-wrap mx-2"
                                id={`${provider}_save-btn`}
                                disabled={!isFormValid}
                                variant="contained"
                                color="primary"
                                onClick={onSave}
                            >
                                Save
                            </Button>
                        </span>
                    </Tooltip>
                )}
                {formType === 'edit' && (
                    <Tooltip
                        arrow
                        title={
                            disableInputs ? 'Cluster must be destroyed (state "down") before it can be updated.'
                                : !isFormValid ? (formInvalidReason || 'Complete all required fields to update.')
                                    : 'Update cluster configuration'
                        }
                    >
                        <span>
                            <Button
                                className="whitespace-no-wrap mx-2"
                                id={`${provider}_update-btn`}
                                disabled={!isFormValid || loading || disableInputs}
                                variant="contained"
                                color="primary"
                                onClick={onEdit}
                            >
                                Update
                            </Button>
                        </span>
                    </Tooltip>
                )}
                <Button
                    className="whitespace-no-wrap ml-2"
                    id={`${provider}_close-btn`}
                    variant="contained"
                    onClick={onClose}
                >
                    Close
                </Button>
            </div>
        </div>
    );
}
